export default __webpack_public_path__ + "static/media/call-sider.ecfd0e22.svg";